import Axios, { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { pointSourceEmissionKeys } from "src/query-keys";
import { APIError, ImportStatus, PointSourceEmission } from "src/types";

export type PointSourceEmissionImportMutationData = {
  pointSourceFile: File;
};

export function usePointSourceEmissionImportMutation(scenarioId: number | string, emissionId: number | string) {
  const queryClient = useQueryClient();

  async function mutationFn(
    scenarioId: number | string,
    emissionId: number | string,
    data: PointSourceEmissionImportMutationData
  ): Promise<void> {
    const config = {
      params: { overwrite: false },
      headers: {
        "Content-Disposition": `attachment; filename="${data.pointSourceFile.name}"`,
      },
    };

    return Axios.put(
      `/planning-api/scenarios/${scenarioId}/pointsourceemissions/${emissionId}/import`,
      data.pointSourceFile,
      config
    );
  }
  return useMutation<void, AxiosError<APIError[]>, PointSourceEmissionImportMutationData, unknown>(
    (values: PointSourceEmissionImportMutationData) => mutationFn(scenarioId, emissionId, values),
    {
      onSettled: async () => {
        queryClient.setQueryData<PointSourceEmission | undefined>(
          pointSourceEmissionKeys.detail(scenarioId, emissionId),
          (value) => {
            if (!value) return undefined;

            return {
              ...value,
              importStatus: ImportStatus.IMPORTING,
            };
          }
        );
        await queryClient.invalidateQueries(pointSourceEmissionKeys.detail(scenarioId, emissionId));
      },
    }
  );
}
